module.exports = __webpack_public_path__ + "img/add-subject.56af4c04.svg";